module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info news--detail"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('sk-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('sk-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.article),
      expression: "article"
    }]
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-panel', {
    staticClass: "article article--detailed"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "md6": ""
    }
  }, [(_vm.article.general != undefined) ? _c('h4', [_vm._v(_vm._s(_vm.article.general.title))]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs2": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__buttons"
  }, [(_vm.article.general != undefined) ? _c('sk-social-share', {
    staticClass: "article__buttons--share",
    attrs: {
      "id": _vm.article.general.id,
      "movie-title": _vm.article.general.title,
      "twitter-text": "What's new at Ster-Kinekor?"
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(_vm.article.general != undefined) ? [_c('p', {
    staticClass: "article__type",
    domProps: {
      "innerHTML": _vm._s(_vm.article.general.type)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "article__date"
  }, [_vm._v(_vm._s(_vm.article.general.date))]), _vm._v(" "), (_vm.article.top_section != undefined) ? [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.article.top_section.copy || _vm.article.top_section.copy)
    }
  })] : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.article.top_section != undefined) ? [(_vm.article.top_section.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": _vm.article.top_section.image.alt ? _vm.article.top_section.image.alt : '',
      "src": _vm.article.top_section.image.url
    }
  })]) : _vm._e()] : _vm._e()], 2)])], 1), _vm._v(" "), (_vm.article.top_section != undefined) ? [(_vm.article.top_section.pdf_file.length > 0) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "small": "",
      "primary": "",
      "tag": "a",
      "href": ("" + (_vm.article.top_section.pdf_file)),
      "target": "_blank"
    }
  }, [_vm._v("More Information")])], 1)], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.article.feature_section != undefined) ? [(_vm.article.feature_section.link) ? _c('div', {
    staticClass: "article__feature embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    attrs: {
      "src": ("" + (_vm.article.feature_section.link)),
      "frameborder": "0",
      "gesture": "media",
      "allow": "encrypted-media",
      "allowfullscreen": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.article.feature_section.image) ? _c('div', {
    staticClass: "article__feature"
  }, [_c('img', {
    attrs: {
      "alt": _vm.article.feature_section.image.alt ? _vm.article.feature_section.image.alt : '',
      "src": _vm.article.feature_section.image.url,
      "alt": ""
    }
  })]) : _vm._e()] : _vm._e()], 2)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(_vm.article.bottom_section != undefined) ? [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.article.bottom_section.copy)
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [(_vm.article.bottom_section != undefined) ? [(_vm.article.bottom_section.image) ? _c('div', {
    staticClass: "article__content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": _vm.article.bottom_section.image.alt ? _vm.article.bottom_section.image.alt : '',
      "src": _vm.article.bottom_section.image.url
    }
  })]) : _vm._e()] : _vm._e()], 2)])], 1), _vm._v(" "), (_vm.article.general != undefined) ? [(_vm.article.general.related_movie) ? _c('sk-button', {
    attrs: {
      "tertiary": "",
      "router": "",
      "to": {
        name: 'Movie Details',
        params: {
          id: _vm.article.general.related_movie
        }
      }
    }
  }, [_vm._v("More info")]) : _vm._e()] : _vm._e()], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5478d1cc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/detail.vue
// module id = 783
// module chunks = 0